import { EditorState, PluginKey } from 'prosemirror-state'
import { State } from './Types'

export const collabItemWidgetKey = new PluginKey<State>('collabItemWidget')

export function getCollabItemWidgetState(editorState: EditorState) {
  const pluginState = collabItemWidgetKey.getState(editorState)
  if (!pluginState) {
    throw new Error('Collab item widget plugin is not registered on the current editor state.')
  }
  return pluginState
}
